import { call, put, takeLatest } from 'redux-saga/effects';

import { sendFormDataApi, sendFileApi } from '../../api';
import {
  formSubmit,
  formSubmitSuccess,
  formSubmitError,
  setFormDescription,
  fileSubmit,
  fileSubmitSuccess,
  fileSubmitError,
} from '../slices/formSlice';

function* formSubmitWorker(action) {
  try {
    const { status, ok, data } = yield call(sendFormDataApi, action.payload);

    if (ok) {
      yield put(formSubmitSuccess(data));
    } else {
      yield put(formSubmitError({ status, data }));
    }
  } catch (err) {
    yield put(formSubmitError(err.message));
  }
}

function* fileSubmitWorker(action) {
  try {
    const response = yield call(sendFileApi, action.payload);

    if (response.error) {
      throw new Error(response.error);
    }

    yield put(fileSubmitSuccess(response));
  } catch (err) {
    yield put(fileSubmitError(err.message));
  }
}

function setFormDescriptionWorker(action) {
  put(setFormDescription(action));
}

export default function* formSaga() {
  yield takeLatest(formSubmit.type, formSubmitWorker);
  yield takeLatest(setFormDescription.type, setFormDescriptionWorker);
  yield takeLatest(fileSubmit.type, fileSubmitWorker);
}
